/*
 * @Author: Li Xingxing
 * @Email: lixingxing@everimaging.com
 * @Date: 2021-11-30 13:58:34
 * @Description: 
 */
import React from "react";
import { autorun } from "mobx"
import FTUserStore from "src/store/FTUserStore";
import FTImageStore from "src/store/FTImageStore";
import FTCanvas from "./FTCanvas";
import NoImageMask from "src/pages/Content/NoImageMask";
import FTNoImageMobile from "src/components/FTNoImageMobile/FTNoImageMobile"
import FTCanvasStore from "src/store/FTCanvasStore";
interface IState {
  isLogin: boolean,
  showCanvas: boolean,
  isMobile: boolean
}

interface IProps {
  className: string
}
class FTCenter extends React.Component<IProps, IState> {
  state: IState = {
    isLogin: false,
    showCanvas: false,
    isMobile: false,
  }
  componentDidMount() {
    autorun(() => {
      let { userInfo } = FTUserStore
      let { currentImage } = FTImageStore
      let { isMobile } = FTCanvasStore
      this.setState({
        isLogin: !!userInfo,
        showCanvas: !!currentImage,
        isMobile: isMobile
      })
    })
  }
  render() {
    let { className } = this.props
    let { showCanvas, isMobile } = this.state
    return <div className={className}>
        { showCanvas ? <FTCanvas /> : isMobile ? <FTNoImageMobile /> : <NoImageMask /> }
      </div>
  }
}

export default FTCenter